import {NotificationManager} from "react-notifications";
import {notificationType} from "../../globals";
import i18next from "../../i18next";

const duration = 4000;

export const createNotification = (type, message, title) => {
  switch (type) {
    case notificationType.INFO:
      NotificationManager.info(message, title, duration);
      break;
    case notificationType.SUCCESS:
      NotificationManager.success(message, title, duration);
      break;
    case notificationType.WARNING:
      NotificationManager.warning(message, title, duration);
      break;
    case notificationType.ERROR:
      NotificationManager.error(message, title, duration);
      break;
    default:
      NotificationManager.info(message, title, duration);
  }
};

export const createInfoNotification = (message, title) => {
  NotificationManager.info(message, title, duration);
};

export const createSuccessNotification = (message, title) => {
  NotificationManager.success(message, title, duration);
};

export const createWarningNotification = (message, title) => {
  NotificationManager.warning(message, title, duration);
};

export const createErrorNotification = (message, title) => {
  NotificationManager.error(message, title, duration);
};


export const createSimpleSuccessNotification = () => {
  createSuccessNotification(i18next.t("notifications.success"));
};

export const createSimpleAxiosWarningNotification = (res) => {
  createWarningNotification("Technical message: " + res?.data?.errors.map(JSON.stringify), i18next.t("notifications.error"))
};

export const createSimpleAxiosErrorNotification =  (e) => {
  createErrorNotification(e.message + ": " + e.response?.data?.error, i18next.t("notifications.error"));
};

const readBlobText = (blob) => {
  if (typeof blob.text === "function") {
    return blob.text();
  }

  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsText(blob);
  });
};

const readErrorBody = async (data) => {
  if (!(data instanceof Blob)) {
    return data;
  }

  try {
    // an HTML error page from the proxy parses as nothing useful - better to
    // show only the status message than to dump a page into a toast
    return JSON.parse(await readBlobText(data));
  } catch (parseError) {
    return null;
  }
};

/**
 * Same as createSimpleAxiosErrorNotification, but for requests made with
 * responseType: "blob" - there the error body arrives as a Blob, so the backend
 * message has to be read out of it first. Falls back to the status message
 * alone for HTML error pages, unexpected shapes and network errors.
 */
export const createDocumentErrorNotification = async (e) => {
  const body = await readErrorBody(e?.response?.data);
  const detail = body?.error ?? body?.message;

  createErrorNotification(
    detail ? `${e.message}: ${detail}` : e.message,
    i18next.t("notifications.error")
  );
};
